import { useEffect, useRef } from 'react';

/** Runs an effect only once per mount cycle (guards React StrictMode double-invoke). */
export const useMountOnce = (effect) => {
  const hasRun = useRef(false);
  const effectRef = useRef(effect);
  effectRef.current = effect;

  useEffect(() => {
    if (hasRun.current) return undefined;
    hasRun.current = true;
    return effectRef.current();
  }, []);
};

/** Runs a fetch when `key` changes; skips duplicate runs for the same key (StrictMode-safe). */
export const useFetchOnceByKey = (key, fetcher, enabled = true) => {
  const lastKey = useRef(null);

  useEffect(() => {
    if (!enabled || key == null || key === '') {
      lastKey.current = null;
      return undefined;
    }

    if (lastKey.current === key) return undefined;
    lastKey.current = key;

    let cancelled = false;
    fetcher({ cancelled: () => cancelled });

    return () => {
      cancelled = true;
      // Allow a remount / StrictMode re-run to fetch again for the same key.
      if (lastKey.current === key) {
        lastKey.current = null;
      }
    };
  }, [key, enabled, fetcher]);
};
